export default __webpack_public_path__ + "5cfe985f26f0f4c252fca59ed2a5fe61.svg";